import React, { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import '../CSS/Drop.css';

const Drop = () => {
  const [uploadStatus, setUploadStatus] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const uploadToCloudinary = async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
      formData.append('cloud_name', process.env.REACT_APP_CLOUDINARY_CLOUD_NAME);

      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/auto/upload`,
        {
          method: 'POST',
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      if (data.secure_url) {
        setUploadedFiles(prev => [...prev, {
          name: file.name,
          url: data.secure_url,
          size: file.size,
          public_id: data.public_id // Store public_id for potential deletion later
        }]);
        setUploadStatus('File uploaded successfully!');
        console.log('Upload success:', data);
        return data;
      } else {
        throw new Error('Upload failed');
      }
    } catch (error) {
      console.error('Upload error:', error);
      setUploadStatus(`Upload failed: ${error.message}`);
      throw error;
    }
  };

  const onDrop = useCallback(async (acceptedFiles) => {
    if (!process.env.REACT_APP_CLOUDINARY_CLOUD_NAME || !process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET) {
      setUploadStatus('Error: Cloudinary configuration missing');
      return;
    }

    setIsUploading(true);
    setUploadStatus('Uploading...');

    try {
      const file = acceptedFiles[0];
      await uploadToCloudinary(file);
    } catch (error) {
      console.error('Drop error:', error);
      setUploadStatus('Upload failed. Please try again.');
    }

    setIsUploading(false);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: false,
    accept: {
      'image/*': ['.jpeg', '.jpg', '.png'],
      'application/pdf': ['.pdf'],
      'application/msword': ['.doc'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx']
    }
  });

  return (
    <div className="drop-container">
      <div 
        {...getRootProps()} 
        className={`dropzone ${isDragActive ? 'active' : ''}`}
      >
        <input {...getInputProps()} />
        {isDragActive ? (
          <p>Drop the file here ...</p>
        ) : (
          <p>Drag 'n' drop a file here, or click to select file</p>
        )}
      </div>
      
      {isUploading && <div className="loader"></div>}
      {uploadStatus && <p className="status-message">{uploadStatus}</p>}
      
      {uploadedFiles.length > 0 && (
        <div className="uploaded-files">
          <h3>Uploaded Files</h3>
          <ul>
            {uploadedFiles.map((file, index) => (
              <li key={index}>
                <a href={file.url} target="_blank" rel="noopener noreferrer">
                  {file.name}
                </a>
                <span className="file-size">
                  ({Math.round(file.size / 1024)} KB)
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Drop;